import { ReactNode } from 'react'

import { DarkModePreferenceGetter, DarkModePreferenceSetter } from './darkModeTypes'

export enum Theme {
  AP = 'Narwhal',
  Cash = 'Unicorn',
  Pegasus = 'Pegasus',
  Kelpie = 'Kelpie',
  KelpieMint = 'KelpieMint',
}

export enum DesignLanguage {
  Bronte = 'Bronte',
  Arcade = 'Arcade',
}

export enum DarkMode {
  System = 'system',
  Dark = 'dark',
  Light = 'light',
}

export interface ThemeProviderConfig {
  children: ReactNode
  theme?: Theme
  darkMode?: DarkMode
  getDarkModePreference?: DarkModePreferenceGetter
  setDarkModePreference?: DarkModePreferenceSetter
}

export interface ThemeProps {
  theme: ThemeControl
}

export interface ThemeControl {
  selected: Theme
  darkMode: DarkMode
  isDarkModeActive: boolean
  setDarkMode: (darkMode: DarkMode) => void
  setTheme: (theme: Theme) => void
  designLanguage: DesignLanguage
}
